let ENV = {
  APP_NAME: "vega",
  APP_ENV: "homolog",
  BASE_URL: "https://sistemas.tel.inf.br/vega_homolog/api/v1",
};

// if (window.location.hostname === "https://vega-ctg.wtfapps.dev.br/") {
//   ENV = {
//     APP_NAME: "vega",
//     APP_ENV: "homolog",
//     BASE_URL: "https://sistemas.tel.inf.br/vega_homolog/api/v1",
//   };
// }

// if (window.location.hostname === "localhost") {
//   ENV = {
//     APP_NAME: "vega",
//     APP_ENV: "homolog",
//     BASE_URL: "https://sistemas.tel.inf.br/vega_homolog/api/v1",
//   };
// }

if (window.location.hostname === "vega-ctg.wtfapps.com.br") {
  ENV = {
    APP_NAME: "vega",
    APP_ENV: "production",
    BASE_URL: "https://sistemas.tel.inf.br/vega_dev/api/v1",
  };
}

export { ENV };
